import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

function SignInPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { signIn, user } = useAuth();
  const navigate = useNavigate();

  // Redirect if already authenticated
  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      const result = await signIn(email, password);

      if (result.success) {
        navigate('/'); // Redirect to main app
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError('Failed to sign in');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-700 flex items-center justify-center relative overflow-hidden">
      {/* Background Pattern/Image - Route Planning Theme */}
      <div className="absolute inset-0 opacity-8">
        {/* Animated route lines */}
        <div className="absolute inset-0">
          <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
            <defs>
              <linearGradient id="routeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.1"/>
                <stop offset="50%" stopColor="#06b6d4" stopOpacity="0.05"/>
                <stop offset="100%" stopColor="#8b5cf6" stopOpacity="0.1"/>
              </linearGradient>
            </defs>
            {/* Curved route paths */}
            <path d="M10,50 Q30,20 50,50 T90,50" stroke="url(#routeGradient)" strokeWidth="0.5" fill="none" className="animate-pulse"/>
            <path d="M20,30 Q40,60 60,30 T80,60" stroke="url(#routeGradient)" strokeWidth="0.3" fill="none" className="animate-pulse" style={{animationDelay: '1s'}}/>
            <path d="M5,70 Q25,40 45,70 T85,40" stroke="url(#routeGradient)" strokeWidth="0.4" fill="none" className="animate-pulse" style={{animationDelay: '2s'}}/>

            {/* Route points/destinations */}
            <circle cx="10" cy="50" r="0.8" fill="#3b82f6" opacity="0.3" className="animate-ping"/>
            <circle cx="50" cy="50" r="0.6" fill="#06b6d4" opacity="0.3" className="animate-ping" style={{animationDelay: '0.5s'}}/>
            <circle cx="90" cy="50" r="0.7" fill="#8b5cf6" opacity="0.3" className="animate-ping" style={{animationDelay: '1.5s'}}/>
          </svg>
        </div>

        {/* Grid overlay */}
        <div className="absolute inset-0 opacity-5">
          <div className="w-full h-full bg-[length:50px_50px] bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGRlZnM+CjxwYXR0ZXJuIGlkPSJncmlkIiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiPgo8cGF0aCBkPSJNIDQwIDAgTCAwIDAgMCA0MCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjOWNhM2FmIiBzdHJva2Utd2lkdGg9IjEiLz4KPC9wYXR0ZXJuPgo8L2RlZnM+CjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz4KPC9zdmc+')]"></div>
        </div>
      </div>


      <div className="max-w-md w-full space-y-8 p-8 relative z-10">
        <div className="text-center">
          <h2 className="text-4xl font-bold text-white mb-2">
            Planner
          </h2>
          <p className="text-slate-300">
            Sign in to access the planning system
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {error && (
            <div className="bg-red-500/10 border border-red-500/20 text-red-400 px-4 py-3 rounded-lg">
              {error}
            </div>
          )}

          <div>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className=""
              placeholder="Email address"
            />
          </div>

          <div>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className=""
              placeholder="Password"
            />
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SignInPage;